var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PillButton',{attrs:{"className":`pill-button${!_vm.isExpanded ? '-inverted' : ''}`,"button-text":`${_vm.isExpanded ? 'HIDE' : 'EXPAND'} FULL PROFILE`,"end-icon":_vm.ChevronUpIcon},on:{"onClick":_vm.toggleIsExpanded}})
}
var staticRenderFns = []

export { render, staticRenderFns }